import type { DialogOptions, DialogService } from '@patsnap/tahiti-core';

export const RequestFeedbackService = Symbol('RequestFeedbackService');

/**
 * 获取反馈的服务
 * @description 用于获取反馈内容
 */
export interface RequestFeedbackService extends DialogService<DialogOptions, string> {
    /**
     * @description 打开反馈对话框
     * @returns 反馈内容
     */
    open(): Promise<string>;
}

